import React, { useEffect, useState } from 'react';
import { Form, Input, Collapse, Button, Space, InputNumber, Select, Checkbox } from 'antd';
import { FaTrash } from '@react-icons/all-files/fa/FaTrash'
import { MONTHS_OPTIONS, YEARS_OPTIONS } from '../../constants';
const { Panel } = Collapse;
export default props => {
    const { form } = props;
    return (
        <>
            <Form.List name="certifications">
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, fieldKey, ...restField }) => {
                            
                            let currentObj = form.getFieldValue('certifications')
                            currentObj = currentObj[key]
                            
                            const educationName = currentObj?.name || currentObj?.provider || `Certification ${name + 1}`;
                            return (
                                <Collapse className="skills-collapse">
                                    <Panel key={`certification-${key}`} align="baseline" className="skill-item" header={(<div className="skill-item-header">
                                        <div className="left">
                                            {educationName}
                                        </div>
                                        <div className="right" >
                                            <FaTrash onClick={() => remove(name)} style={{ cursor: 'pointer' }} />
                                        </div>
                                    </div>)}>
                                        <Form.Item {...restField} name={[name, 'name']} label="Certification Name">
                                            <Input placeholder="Enter certification name" />
                                        </Form.Item>
                                        <Form.Item {...restField} name={[name, 'provider']} label="Provider">
                                            <Input placeholder="Enter provider name" />
                                        </Form.Item>
                                        <Button onClick={() => remove(name)}>Remove</Button>
                                    </Panel>
                                </Collapse>
                            )
                        })}
                        <Button type="dashed" onClick={() => add()} block>
                            Add Certification
                        </Button>
                    </>
                )
                
                }
            </Form.List>
        </>

    )
}